import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ww-time-input" }
const _hoisted_2 = ["min", "max", "step"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "time-separator" }, ":", -1)
const _hoisted_4 = ["min", "max", "step"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      type: "number",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modelValue.hour) = $event)),
      min: _ctx.minHour,
      max: _ctx.maxHour,
      step: _ctx.stepHour,
      onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleChangeHour && _ctx.handleChangeHour(...args)))
    }, null, 40, _hoisted_2), [
      [_vModelText, _ctx.modelValue.hour]
    ]),
    _hoisted_3,
    _withDirectives(_createElementVNode("input", {
      type: "number",
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.modelValue.minute) = $event)),
      min: _ctx.minMinute,
      max: _ctx.maxMinute,
      step: _ctx.stepMinute,
      onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleChangeMinute && _ctx.handleChangeMinute(...args)))
    }, null, 40, _hoisted_4), [
      [_vModelText, _ctx.modelValue.minute]
    ])
  ]))
}